import Snackbar from '@mui/material/Snackbar';

interface ToastProps {
  open: boolean;
  handleClose: () => void;
  message: string;
  vertical?: 'top' | 'bottom';
  horizontal?: 'left' | 'center' | 'right';
}

export const Toast = ({
  open,
  handleClose,
  message,
  vertical = 'top',
  horizontal = 'center',
}: ToastProps) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      open={open}
      onClose={handleClose}
      message={message}
      key={vertical + horizontal}
    />
  );
};
